export const Permissions = {
  CALL_API: 'security_callAPI',
  READ_ATTRIBUTES: 'signages_attributes_read',
};
